import React, {Fragment} from "react";
import PAContentBlock from "../PAContentBlock";
import { Button, Switch, FormGroup, Icon, Input, Notification } from "xsolla-uikit";
import { CSSedit } from '../uikit2'
import { Link } from "react-router-dom";
import { PAloginSBwidget, PAloginSBemail } from "../PAloginSBs";

export default function PAuserNotifications({
  products = []
}) {
  return (
    <Fragment>
<PAContentBlock title="Notification types">
    <FormGroup indentation="lg">
      <Switch
        name="switch_1"
        label="Subscription renewal notification"
        sublabel="User gets an email reminder 3 days before the subscription renews"
        input={{
          value: true,
          onChange: () => {
            void 0;
          }
        }}
      />
    </FormGroup>

    <FormGroup indentation="lg">
      <Switch
        name="switch_1"
        label="Successfull renewal notification"
        sublabel="User gets an email after the subsctiption has been renewed"
        input={{
          value: true,
          onChange: () => {
            void 0;
          }
        }}
      />
    </FormGroup>

    <FormGroup indentation="lg">
      <Switch
        name="switch_1"
        label="Failed renewal notification"
        sublabel="User gets an email if the renewal is unsiccessfull"
        input={{
          value: true,
          onChange: () => {
            void 0;
          }
        }}
      />
    </FormGroup>

    <FormGroup indentation="lg">
      <Switch
        name="switch_1"
        label="Subscription ended notification"
        sublabel="User gets an email when the subscription is suspended"
        input={{
          value: true,
          onChange: () => {
            void 0;
          }
        }}
      />
    </FormGroup>

  </PAContentBlock>

      <PAContentBlock title="Notification emails" border={false}></PAContentBlock>

            <FormGroup indentation="lg">
                <PAloginSBemail editmode={false}>
                  {/* <Link to="/sb0#login_mail">
                    <CSSedit>
                      <div className="l_flex l_flex--center">
                        <FormGroup indentation="lg">
                          <FormGroup indentation="lg">
                            <div className="l_flex l_flex--center">
                              <Button size="lg" appearance="secondary">
                                <Icon name="settings" /> Set up visual
                              </Button>
                            </div>
                          </FormGroup>
                          <FormGroup indentation="lg">
                            <div className="l_flex l_flex--center">
                              <Button size="lg" appearance="flatten">
                                <Icon name="copy" /> Copy widget code
                              </Button>
                            </div>
                          </FormGroup>
                        </FormGroup>
                      </div>
                    </CSSedit>
                  </Link> */}
                </PAloginSBemail>
              </FormGroup>




    </Fragment>
  );
};




const PApromosLine = ({

  id = 19520,
  project_id = 37471,
  project = {
    "id": 37471,
    "localized_name": "Xsolla Store React (xsolla-react-store)"
  },
  technical_name = "Test promo",
  name = {
    "en": "SHORT2"
  },
  description = {
    "en": "SHORT2"
  },
  label = null,
  read_only = true,
  enabled = true,
  is_active = false,
  is_infinite = false,
  show_banner = true,
  timezone = "-07:00",
  datetime = null,
  periods = [
    {
        "from": "2019-09-17T13:06:58",
        "to": "2019-09-17T13:08:00"
    },
    {
        "from": "2019-09-17T13:07:16",
        "to": "2019-09-18T12:00:00"
    }
  ],
  subject = {
    "id": 19520,
    "purchase": true,
    "items": null,
    "packages": null,
    "subscriptions": null,
    "digital_contents": null
  },
  rewards = {
    "id": 19520,
    "purchase": {
        "discount_percent": 90
    },
    "package": {
        "bonus_percent": null,
        "bonus_amount": null
    },
    "item": {
        "discount": [],
        "bonus": []
    },
    "subscription": {
        "trial_days": null
    }
  },
  payment_systems = [],
  payments_count = {
    "minimum": null,
    "maximum": null
  },
  user_attributes = [],
  campaigns = [],
  has_different_offsets = false
}) => {
  return (

    <div className="ui-table__body__row ui-table__body__row--v-align-center" data-id="table.rows[0]">

      <div className="ui-table__column ui-table__column--indentation-sm" style={{ maxWidth: "24%" }}>
        <div className="promotions-row__name">
          <div className="promotions-row__name__extra">
            <a className="promotions-row__name__extra__id" aria-current="false" href="/15924/projects/37471/storefront/promotions/19520">
              ID 19520
              </a>
          </div>
          <a className="promotions-row__name__inner" aria-current="false" href="/15924/projects/37471/storefront/promotions/19520">
            Test promo
            </a>
        </div>
      </div>

      <div className="ui-table__column ui-table__column--indentation-sm" style={{ maxWidth: "20%" }}>
        <div className="promotions-row__bonuses">
          <div className="promotions-row__popover__bonuses__row">
            -90% discount
            </div>
        </div>
      </div>



      <div className="ui-table__column ui-table__column--indentation-sm" style={{ maxWidth: "40%" }}>
        <div className="xsui-popover">
          <div className="promotions-row__periods">
            <div className="promotions-row__periods__item promotions-row__periods__item--passed">
              <div className="promotions-row__periods__item__date">
                9/17/2019
                </div>
              <div className="promotions-row__periods__item__time">
                1:06 PM
                </div>
            </div>
            <div className="promotions-row__periods__item promotions-row__periods__item--passed">
              <div className="promotions-row__periods__item__date">
                9/17/2019
                </div>
              <div className="promotions-row__periods__item__time">
                1:08 PM
                </div>
            </div>
          </div>
          <div className="promotions-row__periods">
            <div className="promotions-row__periods__item promotions-row__periods__item--passed">
              <div className="promotions-row__periods__item__date">
                9/17/2019
                </div>
              <div className="promotions-row__periods__item__time">
                1:07 PM
                </div>
            </div>
            <div className="promotions-row__periods__item promotions-row__periods__item--passed">
              <div className="promotions-row__periods__item__date">
                9/18/2019
                </div>
              <div className="promotions-row__periods__item__time">
                12:00 PM
                </div>
            </div>
          </div>
          <div />
        </div>
      </div>


      <div className="ui-table__column ui-table__column--indentation-sm" style={{ flexShrink: 0, width: 115 }}>

        {enabled && <div className="promotions-row__status">
          <div className="xsui-dropdown">
            <div className="xsui-pill xsui-pill--appearance-active xsui-pill--clickable">
              <div className="xsui-pill__wrapper">
                <div className="xsui-pill_entry">On</div>
              </div>
              <div className="xsui-pill_trigger xsui-pill_trigger--separated">
                <i className="xsui-icon xsui-icon-expand" style={{ fontSize: 24, color: "inherit" }} />
              </div>
            </div>
            <div />
          </div>
        </div>}

        {!enabled && <div className="promotions-row__status"><div className="xsui-dropdown"><div className="xsui-pill xsui-pill--appearance-cancelled xsui-pill--clickable"><div className="xsui-pill__wrapper"><div className="xsui-pill_entry">Off</div></div><div className="xsui-pill_trigger xsui-pill_trigger--separated"><i className="xsui-icon xsui-icon-expand" style={{fontSize: 24, color: 'inherit'}} /></div></div><div /></div></div>
}


      </div>
      <div className="ui-table__column ui-table__column--indentation-sm" style={{ maxWidth: "5%" }}>
        <div className="promotions-row__actions">
          <div style={{ width: 24, height: 24 }}>
            <div className="xsui-dropdown">
              <i className="xsui-icon xsui-icon-more xsui-icon--hoverable" style={{ fontSize: 24, color: "rgb(116, 126, 138)" }} />
              <div />
            </div>
          </div>
        </div>
      </div>

    </div>


  )
}